module.exports = {
	"shared.genres.education": "Vzdělání",
	"social-button.twitter": "Twitter",
	"shared.genres.fantasy": "Fantasy",
	"share-overlay.share": "Sdílet video",
	"overlay.buy-from": "Kupte již od {price}",
	"shared.crew.agent": "Agent",
	"shared.genres.instructional": "Instruktážní",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Kadeřník",
	"social-button.pinterest": "Pinterest",
	"shared.crew.executive-producer": "Výkonný producent",
	"shared.genres.disability-culture": "Disability Culture",
	"shared.genres.asian-american": "Asijsko-americký",
	"shared.genres.native-aboriginal-people": "Rodilí/Domorodí lidé",
	"shared.crew.stunt-coordinator": "Koordinátor kaskadérů",
	"shared.crew.academic-advisor": "Akademický poradce",
	"shared.genres.mature-adult": "Pro dospělé",
	"shared.genres.jewish": "Židovský",
	"shared.genres.drama": "Drama",
	"shared.genres.diy": "Vlastní",
	"shared.genres.youth-teen": "Mladí",
	"quality.format": "{qualityValue}p",
	"shared.genres.film-noir": "Film noir",
	"shared.crew.school-administrator": "Školní správce",
	"shared.genres.family": "Rodina",
	"actions.rent": "Půjčit {price}",
	"shared.genres.news": "Novinky",
	"shared.genres.personal": "Osobní",
	"shared.genres.horror": "Horor",
	"shared.crew.producer": "Producent",
	"shared.genres.animation": "Animace",
	"shared.crew.story": "Děj",
	"shared.genres.black": "Černá",
	"shared.crew.script-supervisor": "Vrchní střihač",
	"shared.crew.production-manager": "Produkční manažer",
	"shared.genres.asian": "Asijský",
	"shared.crew.technical-advisor": "Technický poradce",
	"actions.buy": "Koupit {price}",
	"shared.genres.war": "Válka",
	"shared.crew.assistant-camera": "Asistent kamery",
	"shared.genres.african": "Afričan",
	"shared.crew.writer": "Spisovatel",
	"shared.genres.comedy": "Komedie",
	"shared.crew.collaborating-director": "Spolupracující režisér",
	"shared.crew.assistant-art-director": "Asistent umělecké režie",
	"shared.crew.key-grip": "Vrchní osvětlovač",
	"social-button.link": "Odkaz",
	"shared.genres.music": "Hudba",
	"shared.crew.co-producer": "Koproducent",
	"shared.crew.camera-operator": "Kameraman",
	"shared.crew.co-writer": "Spolupracující scenárista",
	"shared.crew.set-designer": "Design",
	"shared.crew.property-master": "Rekvizitář",
	"shared.genres.history": "Historie",
	"shared.genres.game-show": "Herní show",
	"shared.crew.grip": "Technik",
	"shared.crew.sound-mixer": "Zvukař",
	"quality.label": "Kvalita",
	"shared.genres.children": "Děti",
	"shared.crew.assistant-director": "Asistent režiséra",
	"actions.subscribe": "Příhlásit se k odběru za {price}/měsíc",
	"shared.crew.print-return": "Tisknout znovu",
	"shared.crew.dolly-grip": "Ovladač kamerového vozíku",
	"shared.crew.manager": "Manažer",
	"shared.crew.2nd-assistant-director": "2. asistent režiséra",
	"shared.crew.original-music-composer": "Hudební skladatel",
	"shared.genres.reality-tv": "Reality show",
	"shared.genres.senior-aging": "Starší",
	"shared.crew.publicist": "Publicista",
	"shared.genres.native-american": "Rodilý Američan",
	"shared.crew.associate-producer": "Spolupracovník producenta",
	"shared.crew.assistant-editor": "Asistent střihu",
	"shared.crew.additional-photography": "Další kameraman",
	"shared.crew.sound-editor": "Editor zvuku",
	"shared.crew.makeup-effects": "Speciální makeup",
	"shared.crew.production-assistant": "Asistent produkce",
	"shared.crew.costumer": "Kostymér",
	"info-overlay.cast": "Hrají",
	"shared.genres.documentary": "Dokumentární film",
	"shared.genres.latino": "Latino",
	"shared.genres.african-american": "Afro-Američan",
	"shared.crew.swing-gang": "Swing Gang",
	"shared.genres.action": "Akce",
	"shared.crew.best-boy": "Asistent kameramana",
	"actions.purchased": "Toto video vlastníte",
	"social-button.tumblr": "Tumblr",
	"shared.crew.set-decorator": "Dekorace",
	"shared.genres.islamic": "Islámský",
	"shared.crew.adaptation": "Adaptace",
	"shared.genres.sci-fi": "Sci-Fi",
	"shared.crew.cable-person": "Ovladač zvukových kabelů",
	"shared.crew.digital-effects": "Vizuální efekty",
	"info-overlay.created-by": "od {author}",
	"shared.genres.lgbtq": "LGBTQ",
	"shared.genres.adventure": "Dobrodružství",
	"social-share.twitter": "Sledujte \"{title}\" na {siteUrl}",
	"shared.genres.christian": "Křesťanský",
	"shared.crew.production-designer": "Produkční designér",
	"info-overlay.crew": "Štáb",
	"shared.genres.crime": "Krimi",
	"shared.crew.2nd-unit-dir-of-photography": "2. hlavní kameraman",
	"shared.crew.special-effects": "Speciální efekty",
	"actions.rented": "Pronajato do {date}",
	"shared.crew.boom-operator": "Mistr zvuku",
	"shared.crew.director": "Režisér",
	"shared.crew.choreographer": "Choreograf",
	"quality.auto": "Automaticky",
	"shared.genres.hispanic": "Hispánský",
	"shared.crew.lead-person": "Hlavní osoba",
	"shared.genres.western": "Západní",
	"shared.crew.location-manager": "Manažer lokací",
	"shared.crew.costume-designer": "Návrhy kostýmů",
	"fullscreen.exit": "Ukončit režim celé obrazovky",
	"shared.crew.editor": "Editor",
	"shared.crew.additional-grip": "Vedlejší osvětlovač",
	"shared.genres.talk-show": "Talk-Show",
	"shared.genres.developing-nations": "Rozvojové země",
	"social-share.pinterest": "{title} - {description}",
	"fullscreen.enter": "Celá obrazovka",
	"shared.genres.women": "Ženy",
	"shared.crew.animal-trainer": "Trenér zvířat",
	"social-button.copy": "kopírovat",
	"shared.genres.sport": "Sport",
	"shared.crew.makeup-artist": "Maskér",
	"overlay.source-error": "Video nemůže být přehráno",
	"shared.genres.biography": "Životopis",
	"actions.buy-from": "Kupte již od {price}",
	"shared.crew.art-director": "Umělecký režisér",
	"shared.genres.thriller": "Thriller",
	"shared.crew.production-coordinator": "Produkční koordinátor",
	"shared.crew.co-director": "Asistent režiséra",
	"shared.crew.video-operator": "Obsluha obrazu",
	"shared.genres.romance": "Romantika",
	"shared.crew.preview-return": "Náhled znovu",
	"shared.genres.student": "Student",
	"shared.crew.cinematographer-dp": "Kameraman",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.genres.mystery": "Mysteriózní",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Hlavní osvětlovač",
	"shared.genres.buddhist": "Budhistický",
	"shared.crew.animator": "Animátor",
	"shared.genres.musical": "Hudební",
	"shared.crew.author-of-adapted-material": "Autor adaptace"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_cs.json
// module id = 1433
// module chunks = 0 1 2 3